import { Dashboard, Card } from '@leverege/ui-dashboard';
import DataViewerCardModel from "../../dataViewers/dashboard/DataViewerCardModel.js";
import DataViewerModel from "../../dataViewers/DataViewerModel.js";
import LayoutModel from "../../dataViewers/layout/LayoutModel.js";
export default {
  sort: 1000,
  create(opts) {
    if (opts.client === 'ItemInfoScreen') {
      let dash = Dashboard.create();
      let details = DataViewerCardModel.create(DataViewerModel.create('molten.Details'));
      details = DataViewerCardModel.setHeight(details, '300px');
      dash = Dashboard.addCard(dash, Card.setTitleVisible(Card.create(details), false));
      let mdl = LayoutModel.create();
      mdl = LayoutModel.setMain1(mdl, DataViewerModel.create('molten.Dashboard', dash));
      return mdl;
    }
    return null;
  }
};